const translations = {
  nav_about: "Über uns",
  nav_services: "Leistungen",
  nav_method: "Methode",
  nav_library: "Bibliothek",
  nav_contact: "Kontakt",
  nav_login: "Anmelden",
  nav_register: "Registrieren",
  nav_my_profile: "Mein Profil",
  nav_availability: "Verfügbarkeitsstatus",
  nav_processes: "Meine Prozesse",
  nav_edit: "Informationen bearbeiten",
  nav_privacy: "Datenschutzrichtlinie",
  nav_logout: "Abmelden",
  nav_company_account: "Unternehmenskonto",
  nav_professional_account: "Professionelles Konto",
  hero_badge: "International Placement",
  hero_title_1: "Strategische Talentauswahl in Europa",
  hero_title_2: "International Placement",
  hero_subtitle: "Strategisches Unternehmen für internationale Auswahl und Vermittlung in Europa.",
  hero_markets: "Deutschland · Schweiz · Niederlande · Österreich · Belgien",
  hero_cta_talent: "Talente suchen",
  hero_cta_explore: "Chancen erkunden",
  hero_social_proof: "+120 Fachkräfte in Europa vermittelt",
};

export default translations;
